module.exports = __webpack_public_path__ + "img/wild.d8aba83e.png";